/* BREATHEBOOST+ Mengen-Auswahl (KUNDENKRAFT)
   Steuert die native Xclusive-Variantenauswahl über die Karten, damit Preis, URL,
   Lagerstatus und Warenkorb-Formular weiterhin vom Theme selbst aktualisiert werden.
   Modi:
     - "option": Theme rendert eigene Options-Selektoren (name="options[<section>-Menge]")
                 → Karten klicken die Mengen-Option, andere Optionen bleiben nativ sichtbar
     - "id":     Theme rendert eine flache Variantenliste (Radios/Select name="id")
                 → Karten setzen die Varianten-ID; bei Produkten mit weiteren Optionen (Größe)
                   zeigt der Switcher eigene Options-Pills und kombiniert Größe × Menge */
(function () {
  'use strict';
  if (window.customElements && window.customElements.get('bbq-quantity-switcher')) return;

  function hideNode(node) {
    if (!node) return;
    node.classList.add('bbq-native-hidden');
    var prev = node.previousElementSibling;
    if (prev && prev.tagName === 'LABEL') prev.classList.add('bbq-native-hidden');
  }
  function fmtPrice(cents, currency) {
    var v = (Math.floor(cents) / 100).toFixed(2).replace('.', ',');
    return v + (currency || '');
  }

  function Switcher(root) {
    this.root = root;
    this.scope = root.closest('.shopify-section') || root.closest('form') || document;
    this.cards = Array.prototype.slice.call(root.querySelectorAll('.bbq-card'));
    this.optionName = root.getAttribute('data-option-name') || '';
    this.qidx = parseInt(root.getAttribute('data-option-index') || '0', 10);
    this.currency = root.getAttribute('data-currency') || '';
    this.format = root.getAttribute('data-format') || '{price}';
    this.variants = [];
    var vj = root.querySelector('script.bbq-variants');
    if (vj) { try { this.variants = JSON.parse(vj.textContent); } catch (e) { this.variants = []; } }
    this.native = this.findNative();
    this.opts = Array.prototype.slice.call(root.querySelectorAll('.bbq-opt'));
    this.setupOpts();
    this.bind();
    this.hideNative();
    this.sync();
    this.observe();
  }

  /* Das Theme ersetzt die native Variantenliste nach jedem Wechsel durch frisches Markup
     (fetch + replaceChild) → Referenzen erneuern und Liste wieder ausblenden */
  Switcher.prototype.observe = function () {
    var self = this, timer = null;
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function (muts) {
      var relevant = false;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.nodeType === 1 && !self.root.contains(t) && t !== self.root) { relevant = true; break; }
      }
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        self.native = self.findNative();
        self.hideNative();
        self.sync();
      }, 30);
    });
    mo.observe(this.scope, { childList: true, subtree: true });
  };

  Switcher.prototype.findNative = function () {
    var scope = this.scope, sel;
    var suffix = '-' + this.optionName + ']';
    var radios = Array.prototype.filter.call(
      scope.querySelectorAll('.f8pr-variant-selection:not(.bbq) input[type="radio"][name^="options["]'),
      function (r) { return r.name.slice(-suffix.length) === suffix; }
    );
    if (radios.length) return { type: 'radio', els: radios, key: 'optionValue' };
    sel = Array.prototype.filter.call(
      scope.querySelectorAll('.f8pr-variant-selection:not(.bbq) select[name^="options["]'),
      function (r) { return r.name.slice(-suffix.length) === suffix; }
    )[0];
    if (sel) return { type: 'select', els: [sel], key: 'optionValue' };
    var idRadios = scope.querySelectorAll('.f8pr-variant-selection:not(.bbq) input[type="radio"][name="id"]');
    if (idRadios.length) return { type: 'radio', els: Array.prototype.slice.call(idRadios), key: 'variantId' };
    sel = scope.querySelector('.f8pr-variant-selection:not(.bbq) select[name="id"]');
    if (sel) return { type: 'select', els: [sel], key: 'variantId' };
    var hidden = scope.querySelector('.f8pr-variant-selection:not(.bbq) input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (hidden) return { type: 'hidden', els: [hidden], key: 'variantId' };
    return { type: 'none', els: [], key: 'variantId' };
  };

  /* Eigene Options-Pills nur zeigen, wenn das Theme keine eigenen Selektoren für diese Option rendert */
  Switcher.prototype.setupOpts = function () {
    var self = this;
    this.opts.forEach(function (opt) {
      var name = opt.getAttribute('data-option-name') || '';
      var suffix = '-' + name + ']';
      var nativeSel = Array.prototype.filter.call(
        self.scope.querySelectorAll('.f8pr-variant-selection:not(.bbq) input[name^="options["], .f8pr-variant-selection:not(.bbq) select[name^="options["]'),
        function (r) { return r.name.slice(-suffix.length) === suffix; }
      );
      if (nativeSel.length || self.native.key === 'optionValue') opt.classList.add('bbq-opt-hidden');
      else opt.classList.remove('bbq-opt-hidden');
    });
  };

  Switcher.prototype.hideNative = function () {
    var n = this.native;
    if (n.type === 'none') return;
    if (n.type === 'radio') {
      var lists = [];
      n.els.forEach(function (r) { var ul = r.closest('ul'); if (ul && lists.indexOf(ul) < 0) lists.push(ul); });
      lists.forEach(hideNode);
    } else if (n.type === 'select') {
      var el = n.els[0];
      if (el.classList.contains('js-hidden')) return;
      hideNode(el.closest('p') || el);
    }
  };

  Switcher.prototype.currentValue = function () {
    var n = this.native;
    if (n.type === 'radio') {
      for (var i = 0; i < n.els.length; i++) if (n.els[i].checked) return n.els[i].value;
      return null;
    }
    return n.els[0] ? n.els[0].value : null;
  };

  Switcher.prototype.variantById = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) return this.variants[i];
    return null;
  };

  /* Gewählte Werte der übrigen Optionen (aus eigenen Pills, sonst aus aktueller Variante) */
  Switcher.prototype.otherSelections = function () {
    var self = this, sel = {};
    var cur = this.variantById(this.currentValue() || this.root.getAttribute('data-selected'));
    this.opts.forEach(function (opt) {
      var idx = parseInt(opt.getAttribute('data-option-index'), 10);
      var checked = opt.querySelector('input:checked');
      sel[idx] = checked ? checked.value : (cur ? cur.o[idx] : null);
    });
    return sel;
  };

  Switcher.prototype.findVariant = function (qValue, others) {
    var self = this, best = null;
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      if (v.o[this.qidx] !== qValue) continue;
      var ok = true;
      for (var k in others) { if (others[k] !== null && v.o[k] !== others[k]) { ok = false; break; } }
      if (ok) return v;
      if (!best) best = v;
    }
    return best;
  };

  Switcher.prototype.setValue = function (value) {
    var n = this.native = this.findNative();
    if (n.type === 'radio') {
      for (var i = 0; i < n.els.length; i++) {
        if (n.els[i].value === value) {
          if (!n.els[i].checked) n.els[i].click();
          return true;
        }
      }
      return false;
    }
    if (n.type === 'select' || n.type === 'hidden') {
      var el = n.els[0];
      if (el.value !== value) {
        el.value = value;
        el.dispatchEvent(new Event('change', { bubbles: true }));
        if (n.type === 'hidden' && window.history && window.history.replaceState) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', value); window.history.replaceState({}, '', u.toString()); } catch (e) {}
        }
      }
      return true;
    }
    return false;
  };

  Switcher.prototype.sync = function () {
    var self = this;
    var cur = this.currentValue();
    var curQ = null, curVariant = null;
    if (this.native.key === 'optionValue') {
      curQ = cur !== null ? cur : this.root.getAttribute('data-selected-option');
    } else {
      curVariant = this.variantById(cur !== null ? cur : this.root.getAttribute('data-selected'));
      curQ = curVariant ? curVariant.o[this.qidx] : this.root.getAttribute('data-selected-option');
    }
    var others = this.otherSelections();
    var any = false;
    this.cards.forEach(function (card) {
      var on = card.getAttribute('data-option-value') === String(curQ);
      card.classList.toggle('is-selected', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
      card.tabIndex = on ? 0 : -1;
      if (on) any = true;
      // Preiszeile / Verfügbarkeit an die tatsächliche Variante (Größe × Menge) anpassen
      if (self.native.key === 'variantId' && self.variants.length) {
        var v = self.findVariant(card.getAttribute('data-option-value'), others);
        if (v) {
          card.setAttribute('data-variant-id', v.id);
          card.classList.toggle('is-soldout', !v.a);
          // Bild der tatsaechlichen Variante (z. B. Kleine Groesse) zeigen, sofern kein eigenes Bild gesetzt ist
          if (card.getAttribute('data-auto-img') === '1' && v.img) {
            var im = card.querySelector('.bbq-media img');
            if (im && im.getAttribute('data-bbq-src') !== v.img) {
              im.removeAttribute('srcset'); im.removeAttribute('sizes');
              im.src = v.img; im.setAttribute('data-bbq-src', v.img);
            }
          }
          if (card.getAttribute('data-auto') === '1') {
            var units = parseInt(card.getAttribute('data-units') || '1', 10) || 1;
            var sub = card.querySelector('.bbq-sub');
            if (sub) sub.textContent = self.format
              .replace('{price}', fmtPrice(v.p / units, self.currency))
              .replace('{total}', fmtPrice(v.p, self.currency))
              .replace('{units}', String(units));
          }
        }
      }
    });
    if (!any && this.cards[0]) this.cards[0].tabIndex = 0;
    // Pills mit aktueller Variante abgleichen
    if (curVariant) {
      this.opts.forEach(function (opt) {
        var idx = parseInt(opt.getAttribute('data-option-index'), 10);
        Array.prototype.forEach.call(opt.querySelectorAll('input'), function (r) { r.checked = (r.value === curVariant.o[idx]); });
      });
    }
    this.syncSticky();
  };

  /* Aktuelle Varianten-ID (auch im Options-Modus über das versteckte Theme-Select) */
  Switcher.prototype.currentVariantId = function () {
    if (this.native.key === 'variantId') return this.currentValue() || this.root.getAttribute('data-selected');
    var sel = this.scope.querySelector('.f8pr-variant-selection:not(.bbq) select[name="id"], .f8pr-variant-selection:not(.bbq) input[name="id"]');
    if (sel && sel.value) return sel.value;
    try { return new URL(window.location.href).searchParams.get('variant') || this.root.getAttribute('data-selected'); } catch (e) { return this.root.getAttribute('data-selected'); }
  };

  /* Sticky-Add-to-Cart-Leiste (Xclusive: select name="product_id_sticky") mit der Auswahl synchron halten */
  Switcher.prototype.stickySelect = function () {
    return document.querySelector('#sticky-add-to-cart select[name="product_id_sticky"], select[name="product_id_sticky"]');
  };
  Switcher.prototype.syncSticky = function () {
    var s = this.stickySelect();
    if (!s) return;
    var id = String(this.currentVariantId() || '');
    if (!id || s.value === id) return;
    var has = false;
    for (var i = 0; i < s.options.length; i++) if (s.options[i].value === id) { has = true; break; }
    if (!has) return;
    var self = this;
    this._stickyLock = true;
    s.value = id;
    s.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () { self._stickyLock = false; }, 80);
  };
  /* Auswahl in der Sticky-Leiste → Karten/Theme nachziehen */
  Switcher.prototype.selectVariantId = function (id) {
    id = String(id);
    if (this.native.key === 'variantId') {
      if (this.setValue(id)) { this.sync(); return; }
    }
    var v = this.variantById(id);
    if (!v) return;
    // Options-Modus: jede Option des Themes auf den Wert der Variante setzen
    var self = this, names = {};
    names[this.qidx] = this.optionName;
    this.opts.forEach(function (opt) { names[parseInt(opt.getAttribute('data-option-index'), 10)] = opt.getAttribute('data-option-name'); });
    Object.keys(names).forEach(function (k) {
      var suffix = '-' + names[k] + ']';
      var inputs = Array.prototype.filter.call(
        self.scope.querySelectorAll('.f8pr-variant-selection:not(.bbq) input[name^="options["], .f8pr-variant-selection:not(.bbq) select[name^="options["]'),
        function (r) { return r.name.slice(-suffix.length) === suffix; }
      );
      inputs.forEach(function (inp) {
        if (inp.tagName === 'SELECT') { if (inp.value !== v.o[k]) { inp.value = v.o[k]; inp.dispatchEvent(new Event('change', { bubbles: true })); } }
        else if (inp.value === v.o[k] && !inp.checked) inp.click();
      });
    });
    this.sync();
  };

  Switcher.prototype.select = function (card) {
    var q = card.getAttribute('data-option-value');
    var value, ok;
    if (this.native.key === 'optionValue') {
      value = q;
    } else {
      var v = this.variants.length ? this.findVariant(q, this.otherSelections()) : null;
      value = v ? String(v.id) : card.getAttribute('data-variant-id');
    }
    if (!value) return;
    ok = this.setValue(value);
    if (!ok) this.root.setAttribute(this.native.key === 'optionValue' ? 'data-selected-option' : 'data-selected', value);
    this.sync();
    this.root.dispatchEvent(new CustomEvent('bbq:change', { bubbles: true, detail: { value: value, variantId: card.getAttribute('data-variant-id') } }));
  };

  Switcher.prototype.bind = function () {
    var self = this;
    this.cards.forEach(function (card) {
      card.addEventListener('click', function (e) { e.preventDefault(); self.select(card); });
      card.addEventListener('keydown', function (e) {
        var idx = self.cards.indexOf(card), n = self.cards.length, t;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') t = self.cards[(idx + 1) % n];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') t = self.cards[(idx - 1 + n) % n];
        else if (e.key === ' ' || e.key === 'Enter') t = card;
        if (t) { e.preventDefault(); t.focus(); self.select(t); }
      });
    });
    // eigene Options-Pills (Größe): Variante = Pill-Wert × aktuell gewählte Menge
    this.opts.forEach(function (opt) {
      opt.addEventListener('change', function (e) {
        e.stopPropagation();
        var selCard = self.cards.filter(function (c) { return c.classList.contains('is-selected'); })[0] || self.cards[0];
        if (selCard) self.select(selCard);
      });
    });
    // Theme-seitige Änderungen (URL, Theme-JS) zurückspiegeln
    this.scope.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.bbq-opt')) return;
      setTimeout(function () { self.sync(); }, 0);
    });
    // Sticky-Add-to-Cart: Auswahl dort → Karten + Hauptformular (das Theme-Dropdown feuert
    // nicht-bubbelnde change-Events, daher direkt am Select binden und regelmäßig neu prüfen)
    this.bindSticky();
    setInterval(function () { self.bindSticky(); }, 1500);
  };

  Switcher.prototype.bindSticky = function () {
    var self = this, s = this.stickySelect();
    if (!s || s.__bbqBound) return;
    s.__bbqBound = true;
    var timer = null;
    // Nur auf echte Nutzer-Interaktion in der Sticky-Leiste reagieren: das Theme setzt den Select-Wert
    // nach jedem Variantenwechsel selbst neu (mit change-Events) und wuerde sonst die Auswahl zurueckdrehen
    if (!document.__bbqStickyUserBound) {
      document.__bbqStickyUserBound = true;
      ['mousedown', 'touchstart', 'keydown'].forEach(function (t) {
        document.addEventListener(t, function (e) {
          if (e.target && e.target.closest && e.target.closest('#sticky-add-to-cart')) document.__bbqStickyUserTs = Date.now();
        }, true);
      });
    }
    s.addEventListener('change', function () {
      if (self._stickyLock) return;
      if (!document.__bbqStickyUserTs || Date.now() - document.__bbqStickyUserTs > 2000) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var id = s.value;
        if (id && String(self.currentVariantId()) !== String(id)) self.selectVariantId(id);
      }, 40);
    });
  };

  function relocate(root) {
    if (root.__bbqMoved) return true;
    var host = root.closest('[data-bbq-host]');
    if (!host) return true;
    var main = document.querySelector('.shopify-section article#main-product, .shopify-section .m6pr') || document;
    var native = main.querySelector('.f8pr .f8pr-variant-selection:not(.bbq)');
    var target = native ? native.parentNode : main.querySelector('.f8pr');
    if (!target) return false;
    target.insertBefore(root, native || target.querySelector('form[action*="/cart/add"]') || null);
    root.__bbqMoved = true;
    return true;
  }

  function init(root) {
    if (!root || root.__bbq) return;
    if (!relocate(root)) return;
    root.__bbq = new Switcher(root);
  }

  if (window.customElements) {
    var Base = window.HTMLElement;
    function BBQElement() { return Reflect.construct(Base, [], BBQElement); }
    BBQElement.prototype = Object.create(Base.prototype);
    BBQElement.prototype.constructor = BBQElement;
    BBQElement.prototype.connectedCallback = function () {
      var self = this;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(self); });
      else setTimeout(function () { init(self); }, 0);
    };
    window.customElements.define('bbq-quantity-switcher', BBQElement);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      Array.prototype.forEach.call(document.querySelectorAll('bbq-quantity-switcher'), init);
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('bbq-quantity-switcher'), function (el) {
      var sid = el.getAttribute('data-section');
      Array.prototype.forEach.call(document.querySelectorAll('bbq-quantity-switcher[data-section="' + sid + '"]'), function (old) {
        if (old !== el && old.__bbqMoved) old.parentNode.removeChild(old);
      });
      el.__bbq = null; el.__bbqMoved = false; init(el);
    });
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var sid = e.detail && e.detail.sectionId;
    if (!sid) return;
    Array.prototype.forEach.call(document.querySelectorAll('bbq-quantity-switcher[data-section="' + sid + '"]'), function (old) {
      if (old.__bbqMoved) {
        old.parentNode.removeChild(old);
        Array.prototype.forEach.call(document.querySelectorAll('.bbq-native-hidden'), function (n) { n.classList.remove('bbq-native-hidden'); });
      }
    });
  });
})();
